// extracted by mini-css-extract-plugin
export default {"tags":"uxcSe4IK","desktop":"BYm0aupm","tag":"L5aD8I6J","divider":"_CK5V0l5","letter":"LEJoJ9NH"};